// src/zustand/cityStore.ts
import { create } from "zustand";

interface CityStore {
  selectedCity: string;
  setSelectedCity: (city: string) => void;
}

export const useCityStore = create<CityStore>(
  (set: (partial: Partial<CityStore>) => void) => ({
    selectedCity: "selectCity",
    setSelectedCity: (city: string) => {
      console.log("Zustand store updating selectedCity to:", city);
      set({ selectedCity: city });
    },
  })
);
